var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInactiveUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.5,
    height: 16.979,
    viewBox: "0 0 15.5 16.979",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .inactiveUser {\r\n        fill: #8c8d99;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline_Communication_User",
    "data-name": "Outline / Communication /User",
    transform: "translate(-4.25 -3.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User",
    transform: "translate(4 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "inactiveUser",
    d: "M4.25,8.5A4.25,4.25,0,1,1,8.5,4.25,4.255,4.255,0,0,1,4.25,8.5Zm0-7A2.75,2.75,0,1,0,7,4.25,2.753,2.753,0,0,0,4.25,1.5Z",
    transform: "translate(3.75 0.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    className: "inactiveUser",
    d: "M7.75,6.979a40.173,40.173,0,0,1-6.46-.524A1.531,1.531,0,0,1,0,4.938V3.75A3.755,3.755,0,0,1,3.75,0h.34a1.74,1.74,0,0,1,.544.086L5.5.369A7.228,7.228,0,0,0,7.75.727,7.235,7.235,0,0,0,10,.369l.865-.283A1.74,1.74,0,0,1,11.409,0h.341A3.754,3.754,0,0,1,15.5,3.75V4.938a1.531,1.531,0,0,1-1.289,1.516A40.186,40.186,0,0,1,7.75,6.979ZM3.75,1.5A2.253,2.253,0,0,0,1.5,3.75V4.938a.036.036,0,0,0,.031.036,38.668,38.668,0,0,0,6.219.5,38.668,38.668,0,0,0,6.219-.5A.037.037,0,0,0,14,4.938V3.75A2.253,2.253,0,0,0,11.75,1.5h-.341a.248.248,0,0,0-.077.012l-.866.283a8.728,8.728,0,0,1-2.716.433,8.728,8.728,0,0,1-2.716-.433l-.865-.283A.252.252,0,0,0,4.091,1.5Z",
    transform: "translate(0.25 10.25)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveUser);
export default __webpack_public_path__ + "static/media/inactive-user.7eadf8a2b1cf3b0e58bf15da02ae604f.svg";
export { ForwardRef as ReactComponent };